import React from 'react';
import { 
  Box, 
  Paper, 
  Typography, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,
  Chip,
  IconButton,
  Tooltip
} from '@mui/material';
import { 
  Refresh as RefreshIcon,
  PlayArrow as PlayArrowIcon,
  Info as InfoIcon
} from '@mui/icons-material';

const RunHistory = ({ automationId, history = [], onRefresh, onReplay }) => {
  const getStatusColor = (status) => {
    if (!status) return 'default';
    
    switch (status.toLowerCase()) {
      case 'passed':      // backend entity emits 'passed'; legacy 'success' kept as alias
      case 'success':
        return 'success';
      case 'failed':
        return 'error';
      case 'running':
        return 'info';
      default:
        return 'default';
    }
  };

  return (
    <Box sx={{ width: '100%', mb: 3 }}>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6">Run History</Typography>
          <Tooltip title="Refresh">
            <IconButton onClick={onRefresh}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </Box>
        
        {history.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 3 }}>
            No run history available for this automation.
          </Typography>
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Duration</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Trigger</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {history.map((run) => {
                  // Backend entity uses startedAt + durationMs; legacy code
                  // had startTime + duration — support both so this component
                  // works regardless of upstream data shape.
                  const started = run.startedAt || run.startTime;
                  const durSecs = run.durationMs != null
                    ? Math.round(run.durationMs / 100) / 10
                    : run.duration;
                  return (
                  <TableRow key={run.id}>
                    <TableCell>
                      {started ? new Date(started).toLocaleString() : 'N/A'}
                    </TableCell>
                    <TableCell>
                      {durSecs != null ? `${durSecs}s` : 'N/A'}
                    </TableCell>
                    <TableCell>
                      <Chip 
                        label={run.status} 
                        size="small" 
                        color={getStatusColor(run.status)}
                      />
                    </TableCell>
                    <TableCell>{run.trigger || 'Manual'}</TableCell>
                    <TableCell>
                      <Tooltip title="Replay">
                        <span>
                          <IconButton
                            size="small"
                            onClick={() => onReplay(run.id)}
                            disabled={run.status === 'running'}
                          >
                            <PlayArrowIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title="View Details">
                        <IconButton size="small">
                          <InfoIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
    </Box>
  );
};

export default RunHistory;
